import { Motion, Direction } from "./types"
import * as joystick from "./joystick"

const idleTimeout = 7000

export class Input {

	static state = Motion.IDLE
	static steeringOn = false
	static player = null as any
	static key = {
		pageUp: false,
		pageDown: false,
		left: false,
		right: false,
		up: false,
		jup: false,
		down: false,
		run: false,
		slow: false,
		idle: false,
		ctrl: false,
		alt: false,
		space: false
	}
	// Non-steering data
	static distance = 0
	static angle = 0
	static idleTimeout: NodeJS.Timeout
	static keyboardSetup = false
	static keysEnabled = false
	
	static joystickLastDeltaX = 0
	static totalDeltaX = 0
	static joystickDeadZone = 0.03
	static vj:joystick.VirtualJoystick|null = null
	static allKeysOff() {
		Input.key.down = false;
		Input.key.up = false;
		Input.key.jup = false;
		Input.key.run = false;
		Input.key.slow = false;
		Input.key.right = false;
		Input.key.left = false;
	}

	static keydownEvent(e: KeyboardEvent) {
		clearTimeout(this.idleTimeout)
		this.idleTimeout = setTimeout(Input.idle,idleTimeout)
		Input.key.idle = false
		if (Input.keysEnabled) {
			Input.joystickLastDeltaX = 0
			switch (e.key) {
				case "Shift":
					Input.key.run = true
					break
				case " ":
					Input.key.slow = true
					break
				case "ArrowDown":
				case "S":
				case "s":
					Input.key.down = true
					break
				case "ArrowUp":
				case "W":
				case "w":
					Input.key.up = true
					break
				case "ArrowLeft":
				case "A":
				case "a":
					Input.key.left = true
					Input.player.direction = Direction.LEFT
					break
				case "ArrowRight":
				case "D":
				case "d":
					Input.key.right = true
					Input.player.direction = Direction.RIGHT
					break
			}
		}
	}

	static keyupEvent(e: KeyboardEvent) {
		if (Input.keysEnabled) {
			clearTimeout(this.idleTimeout)
			this.idleTimeout = setTimeout(this.idle,idleTimeout)
			Input.key.idle = false
			Input.joystickLastDeltaX = 0
			switch (e.key) {
				case "Shift":
					Input.key.run = false;
					break;
				case " ":
					Input.key.slow = false;
					break;
				case "ArrowDown":
				case "S":
				case "s":
					Input.key.down = false;
					break;
				case "ArrowUp":
				case "W":
				case "w":
					Input.key.up = false
					break;
				case "ArrowLeft":
				case "A":
				case "a":
					Input.key.left = false;
					break;
				case "ArrowRight":
				case "D":
				case "d":
					Input.key.right = false;
					break;
			}
		}
	}

	static blurEvent() {
		Input.key.down = false
		Input.key.up = false
		Input.key.left = false
		Input.key.right = false
		Input.key.idle = false
	}

	static preventDefault(e: any) {
		e.preventDefault()
	}

	static setupKeyboard() {
		document.addEventListener("keydown", Input.keydownEvent)
		document.addEventListener("keyup", Input.keyupEvent)
		document.addEventListener("blur", Input.blurEvent)
		Input.keyboardSetup = true
	}

	static toggleSteeringWheel(on: boolean) {
		if (on) {
			Input.steeringOn = true
			Input.vj!.joystickMove = this.steeringMove
			Input.vj!.joystickUp = this.joystickUp
		} else {
			Input.steeringOn = false
			Input.vj!.joystickMove = this.nonsteeringMove
		}
	}

	static setupJoystick() {
		Input.vj = new joystick.VirtualJoystick(
			this.nonsteeringMove,
			this.joystickUp
		)			
		Input.vj!.setJoystickColor("#101010")
		clearTimeout(this.idleTimeout)
		this.idleTimeout = setTimeout(this.idle,idleTimeout)
		Input.key.idle = false

		window.addEventListener("pointerup", (event: any) => {
			clearTimeout(this.idleTimeout)
			this.idleTimeout = setTimeout(this.idle,idleTimeout)
			Input.key.idle = false	
		})
	}

	static idle() {
		Input.key.idle = true
	}

	static joystickUp = () => {
		Input.allKeysOff()
	}

	static nonsteeringMove = (_deltaJoystickVector: BABYLON.Vector2) => {
		const rad = Math.atan2(_deltaJoystickVector.y, _deltaJoystickVector.x)
		const distance = Math.sqrt( _deltaJoystickVector.x*_deltaJoystickVector.x + _deltaJoystickVector.y*_deltaJoystickVector.y)
		Input.distance = distance
		Input.angle = rad

		clearTimeout(this.idleTimeout)
		this.idleTimeout = setTimeout(this.idle,idleTimeout)
		Input.key.idle = false
		//Up and down
		if (distance > 60) {
			Input.key.run = true
		} else {
			Input.key.run = false
		}
		if (distance > 20) {
			Input.key.jup = true
		} else {
			Input.key.jup = false
		}
		if ((distance > 20) && (distance < 40)) {
			Input.key.slow = true
		} else {
			Input.key.slow = false
		}		
	}

	static steeringMove = (_deltaJoystickVector: BABYLON.Vector2) => {
		if (!Input.keysEnabled) return
		clearTimeout(this.idleTimeout)
		this.idleTimeout = setTimeout(this.idle,idleTimeout)
		Input.key.idle = false

		//Left and right
		var deltaX = _deltaJoystickVector.x / 100
		//Going right
		if (deltaX > Input.joystickLastDeltaX) {
			if (Input.totalDeltaX > Input.joystickDeadZone) {
				Input.key.left = false
				Input.key.right = true
			} else {
				//in deadzone
				if (Input.totalDeltaX < 0) {
					Input.totalDeltaX = 0
				}
				Input.key.left = false
				Input.totalDeltaX += (deltaX - Input.joystickLastDeltaX)
			}
			//Going left
		} else if (deltaX < Input.joystickLastDeltaX) {
			if (Input.totalDeltaX < (-1 * Input.joystickDeadZone)) {
				Input.key.right = false
				Input.key.left = true
			} else {
				//in deadzone
				if (Input.totalDeltaX > 0) {
					Input.totalDeltaX = 0
				}
				Input.key.right = false
				Input.totalDeltaX += (deltaX - Input.joystickLastDeltaX)
			}
		}

		Input.joystickLastDeltaX = deltaX

		//Up and down
		if ((_deltaJoystickVector.y < -60) || (_deltaJoystickVector.y > 60)) {
			Input.key.run = true
		} else {
			Input.key.run = false
		}
		if (_deltaJoystickVector.y < 20) {
			Input.key.up = true
			Input.key.down = false
		}
		if (_deltaJoystickVector.y > 20) {
			Input.key.down = true
			Input.key.up = false
		}
		if ((_deltaJoystickVector.y > -40) && (_deltaJoystickVector.y < 40)) {
			Input.key.slow = true
		} else {
			Input.key.slow = false
		}

		if ((_deltaJoystickVector.y < 20) && (_deltaJoystickVector.y > -20)) {
			Input.key.down = false
			Input.key.up = false
			Input.key.run = false
			Input.key.slow = false
		}
	}
}


